import { RootState } from "../../../rootState";

export default class AltitudeRangeSelector {
    static getLowerLimit(state: RootState) {
        return state.altitudeRange && state.altitudeRange.lowerLimit;
    }
    static getUpperLimit(state: RootState) {
        return state.altitudeRange && state.altitudeRange.upperLimit;
    }
    static getUnits(state: RootState) {
        return state.altitudeRange && state.altitudeRange.units;
    }
}
